import { render } from "./Fonctionnalite.vue?vue&type=template&id=2952ac9e&scoped=true"
import script from "./Fonctionnalite.vue?vue&type=script&lang=js"
export * from "./Fonctionnalite.vue?vue&type=script&lang=js"

import "./Fonctionnalite.vue?vue&type=style&index=0&id=2952ac9e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2952ac9e"]])

export default __exports__